import { Box, Button, FormControlLabel, Grid, TextField } from '@mui/material'
import apiAppVersions from 'api/app-verisons'
import ItemFile from 'components/common/file/ItemFile'
import { convertTypeFile } from 'components/common/file/function'
import { DOMAIN_DESKTOP_DOWNLOAD } from 'constants/api'
import { TYPE_FILES } from 'constants/files'
import { lowerCase, upperCase } from 'lodash'
import { generateUniqueString } from 'pages/manager-meeting/functions'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import SwitchIOS from 'shared/components/base/SwitchIOS'
import { toastError } from 'utils/helpers'
import { ReactComponent as IconUploadFiles } from '../../../assets/img/IconUploadFilesNew.svg'
import CircularProgressWithLabel from './CircularProgressWithLabel'

const ItemUploadFile = ({
    label,
    name,
    isRequired = true,
    fileHandle,
    t,
    register,
    unregister,
    registerName,
    handleUpload,
    handleUploadFile,
    handleChangeType,
    type,
    errors,
    setValue
}) => {

    useEffect(() => {
        if (fileHandle[name].isUploaded) unregister(registerName)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fileHandle[name].isUploaded])

    return (
        <Grid item xs={12} sm={4}>
            <FormControlLabel
                id={`version-upload-${name}`}
                label={label}
                labelPlacement={'top'}
                htmlFor={name}
                required={isRequired}
                sx={{ cursor: "default" }}
                control={
                    <div>
                        <Box display={'flex'} gap={1} mb={1}>
                            <Button id={`btn-upload-${name}`} disabled={fileHandle[name].isUploading || !fileHandle[name].isUploaded} variant='outlined' startIcon={<IconUploadFiles />} onClick={() => handleUpload(name)}>{t('actions.upload')}</Button>
                            {fileHandle[name].isUploading && <CircularProgressWithLabel value={fileHandle[name].progress} />}
                            <SwitchIOS
                                id={`switch-upload-${name}`}
                                checked={fileHandle[name].isUploaded}
                                onChange={(e) => handleChangeType({ type: name, value: e.target.checked })}
                            />
                        </Box>
                        {fileHandle[name].isUploaded && <input id={`${name}-upload`} accept={name === 'doc' ? '*/*' : `.${name}`} type='file' style={{ display: 'none' }} onChange={(e) => handleUploadFile(e, type)} />}
                        {fileHandle[name].file && <ItemFile file={fileHandle[name].file} isDownload={false} />}
                        {!fileHandle[name].isUploaded && <TextField id={`input-upload-${name}`} sx={{ mt: fileHandle[name].file ? 1 : 0 }} {...register(registerName, { required: !isRequired || "validate.versionUrlRequired", maxLength: { value: 500, message: "validate.maxLengthText" }, setValueAs: (value) => (value ? value : "") })} placeholder={t('placeholder.enterVersionUrl')} fullWidth error={!!errors[registerName]} helperText={errors[registerName] ? t(errors[registerName].message, { num: 500 }) : ""} onBlur={(e) => {
                            const trimmed = e?.target?.value?.trim();
                            setValue(registerName, trimmed, { shouldValidate: true, shouldDirty: true });
                        }} />}
                    </div>
                }
            />
        </Grid>
    )
}

const UploadFileHandle = ({
    fileHandle,
    setFileHandle,
    setValue,
    register,
    unregister,
    errors
}) => {

    const { t } = useTranslation()

    const handleUpload = (type = 'doc') => {
        try {
            if (fileHandle[type].isUploaded) return document.querySelector(`#${type}-upload`).click()
            return
        } catch (error) {
            console.log('error', error)
        }
    }

    const handleUploadFile = async (e, type) => {
        let _slot = undefined
        const _type = lowerCase(type)
        try {
            const file = e.target.files[0]
            if (!file) return
            if (convertTypeFile(file?.name) !== type && type !== 'doc') return toastError('File không hợp lệ')

            _slot = generateUniqueString()
            let formData = new FormData();

            formData.append('files', file);
            formData.append('names', file?.name);

            setFileHandle(prev => ({
                ...prev,
                [_type]: {
                    ...prev[_type],
                    isUploading: true
                }
            }))

            const res = await apiAppVersions.upload({
                slot: _slot,
                data: formData,
                onUploadProgress: (e) => {
                    setFileHandle(prev => ({
                        ...prev,
                        [_type]: {
                            ...prev[_type],
                            progress: Math.round(e.loaded * 100 / e.total)
                        }
                    }))
                }
            })

            if (res?.path) {
                const os = type === TYPE_FILES.EXE ? 'win_url' : type === TYPE_FILES.DMG ? 'mac_url' : type === TYPE_FILES.DEB ? 'deb_url' : 'manual_url'
                setValue(os, `${DOMAIN_DESKTOP_DOWNLOAD}${res.path}`)
            } else return

            setFileHandle(prev => ({
                ...prev,
                [_type]: {
                    ...prev[_type],
                    progress: 100
                }
            }))

            setTimeout(() => {
                setFileHandle(prev => ({
                    ...prev,
                    [_type]: {
                        ...prev[_type],
                        progress: 0,
                        isUploading: false,
                        file: file,
                        slot: res?.id
                    }
                }))
            }, 250)
        } catch (err) {
            setFileHandle(prev => ({
                ...prev,
                [_type]: {
                    ...prev[_type],
                    progress: 0,
                    isUploading: false,
                    file: undefined,
                    slot: undefined
                }
            }))
        }
    }

    const handleChangeType = ({ type, value }) => {
        const _type = upperCase(type)
        const os = _type === TYPE_FILES.EXE ? 'win_url' : _type === TYPE_FILES.DMG ? 'mac_url' : _type === TYPE_FILES.DEB ? 'deb_url' : 'manual_url'
        if (!value) {
            setValue(os, '')
            setFileHandle(prev => ({
                ...prev,
                [type]: {
                    ...prev[type],
                    isUploaded: value,
                    file: undefined
                }
            }))
        } else {
            setValue(os, '')
            setFileHandle(prev => ({
                ...prev,
                [type]: {
                    ...prev[type],
                    isUploaded: value
                }
            }))
        }
    }

    return (
        <>
            <ItemUploadFile fileHandle={fileHandle} handleChangeType={handleChangeType} handleUpload={handleUpload} handleUploadFile={handleUploadFile} label={t('label.versionWin')} name={'exe'} register={register} unregister={unregister} registerName={'win_url'} type={TYPE_FILES.EXE} t={t} isRequired={true} setValue={setValue} errors={errors} />
            <ItemUploadFile fileHandle={fileHandle} handleChangeType={handleChangeType} handleUpload={handleUpload} handleUploadFile={handleUploadFile} label={t('label.versionMacos')} name={'dmg'} register={register} unregister={unregister} registerName={'mac_url'} t={t} type={TYPE_FILES.DMG} isRequired={true} setValue={setValue} errors={errors} />
            <ItemUploadFile fileHandle={fileHandle} handleChangeType={handleChangeType} handleUpload={handleUpload} handleUploadFile={handleUploadFile} label={t('label.versionLinux')} name={'deb'} register={register} unregister={unregister} registerName={'deb_url'} t={t} type={TYPE_FILES.DEB} isRequired={true} setValue={setValue} errors={errors} />
            <ItemUploadFile fileHandle={fileHandle} handleChangeType={handleChangeType} handleUpload={handleUpload} handleUploadFile={handleUploadFile} label={t('label.guide')} name={'doc'} register={register} unregister={unregister} registerName={'manual_url'} t={t} type={'doc'} isRequired={false} setValue={setValue} errors={errors} />
        </>
    )
}

export default UploadFileHandle